import { render, staticRenderFns } from "./AddIconDialog.vue?vue&type=template&id=f1a09308&"
import script from "./AddIconDialog.vue?vue&type=script&lang=js&"
export * from "./AddIconDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports